import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Products } from './pages/Products';
import { ProductCategory } from './pages/ProductCategory';
import { ProductDetail } from './pages/ProductDetail';
import { Applications } from './pages/Applications';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { ThankYou } from './pages/ThankYou';
import { isRTL, getLangFromPath, stripLangFromPath } from './i18n/config';

export default function App() {
  const location = useLocation();
  const { i18n } = useTranslation();

  // 从 URL 提取语言（/zh/products -> zh，/products -> en）
  const lang = getLangFromPath(location.pathname);
  // 去掉语言前缀后的路径，用于内部路由匹配
  const pathWithoutLang = stripLangFromPath(location.pathname);

  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    document.documentElement.lang = lang;
    document.documentElement.dir = isRTL(lang) ? 'rtl' : 'ltr';
  }, [lang, i18n]);

  return (
    <Layout lang={lang}>
      {/* 用 location 覆盖，让内部路由按去掉语言前缀后的路径匹配 */}
      <Routes location={{ ...location, pathname: pathWithoutLang }}>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:category" element={<ProductCategory />} />
        <Route path="/products/:category/:productId" element={<ProductDetail />} />
        <Route path="/applications" element={<Applications />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/company" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/thank-you" element={<ThankYou />} />
      </Routes>
    </Layout>
  );
}
